import React, { useState, useRef, useEffect } from "react";
import { Link } from 'react-router-dom';
import "./DropdownNew.css"
import TelegramSvg from "./telegram.svg"
import DiscordSvg from "./discord.svg"
import PawSvg from "./paw.svg"
import TwitterXSvg from "./twitter-x.svg"

function DropdownNew3() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown if click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
            <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
                <button className = "button-dropdown" onClick={() => setOpen(!open)}>Join Our Groups ▼</button>
                {open && (
                <ul
                    style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                backgroundColor: "white",
                                border: "1px solid gray",
                                padding: 0,
                                margin: 0,
                                listStyle: "none",
                                width: "200px",
                                zIndex: 1000,
                            }}
                            >
                               <li>
                              <Link to="/groups"  className = "dropdown-link" >Our Groups Information Page</Link></li>
                            <li>
                              <Link to="https://t.me/+LPKHccQiNR03ZDQ7"  className = "dropdown-link" ><img alt = "telegram" src= {TelegramSvg}></img> Telegram</Link></li>
                            <li>
                              <Link to="https://discord.gg/nXGUjUpXQG" className = "dropdown-link" > <img alt = "discord" src= {DiscordSvg}></img> Discord</Link></li>
                            <li>
                              <Link to="https://www.furaffinity.net/user/socalfurs" className = "dropdown-link" > <img alt = "pawpad" className = "svg-link-downsize" src= {PawSvg}></img> Furaffinity</Link></li>
                            <li>
                              <Link to="https://twitter.com/socal_furs"  className = "dropdown-link" > <img src= {TwitterXSvg}></img> Twitter / X</Link></li>
                              
                              
                </ul>
            )}
        </div>
    
    </div>
    
  );
}

export default DropdownNew3;
